export * from './ui/dialog-edit-fecha-pago-programada/dialog-edit-fecha-pago-programada.component';
export * from './ui/dialog-edit-fecha-pago-programada/edit-fecha-pago-dialog.config';
